import jwt_decode from 'jwt-decode';
import { UtilizadorModel } from '@core/models';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  setSessionAttr(key: string, value): any {
    window.localStorage.setItem(key, value);
  }

  getSessionAttr(key: string): any {
    const data = window.localStorage.getItem(key);

    return data;
  }

  storeSession(data) {
    const { token } = data;

    if (token) {
      const utilizador = jwt_decode<UtilizadorModel>(token);
      this.setSessionAttr('token', token);
      this.setSessionAttr('utilizador', JSON.stringify(utilizador));
    }
  }

  destroySession() {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('utilizador');
  }

  isAuthenticated(): boolean {
    const token = window.localStorage.getItem('token');

    const isLogged = token ? true : false;
    return isLogged;
  }
}
